import { DownloadCloud, ChevronLeft, Search } from "lucide-react";

const APPS = [
  { name: "Т-Банк", date: "20 сен 2024", icon: "/assets/icons/tbank.jpg" },
  { name: "Сбербанк", date: "19 сен 2024", icon: "/assets/icons/sber.jpg" },
  { name: "Сбер Kids", date: "18 сен 2024", icon: "/assets/icons/sberkids.jpg" },
  { name: "VK Видео", date: "17 сен 2024", icon: "/assets/icons/vkvideo.jpg" },
  { name: "VK Музыка", date: "16 сен 2024", icon: "/assets/icons/vkmusic.jpg" },
  { name: "VK", date: "15 сен 2024", icon: "/assets/icons/vk.jpg" },
  { name: "MAX", date: "14 сен 2024", icon: "/assets/icons/max.jpg" },
];

const norm = (s) => (s || "").toLowerCase().replace(/\s+/g, "");

function matchIndex(name) {
  if (!name) return 0;
  const n = norm(name);
  const idx = APPS.findIndex((a) => {
    const an = norm(a.name);
    return an === n || n.includes(an) || an.includes(n);
  });
  return idx >= 0 ? idx : 0;
}

export function PurchasesShot({ highlightName, width = 240 }) {
  const hi = matchIndex(highlightName);
  return (
    <div
      data-testid="purchases-shot"
      style={{ width }}
      className="mx-auto rounded-[20px] overflow-hidden border border-white/10 bg-black text-white select-none"
    >
      <div className="flex items-center justify-between px-3 pt-3 pb-2 text-[11px]">
        <span className="flex items-center text-blue-400">
          <ChevronLeft size={14} />
          Account
        </span>
        <span className="font-semibold text-[12px]">Apps</span>
        <span className="text-blue-400">Done</span>
      </div>

      <div className="px-3 pb-2">
        <div className="flex rounded-lg bg-white/10 p-0.5 text-[10px]">
          <span className="flex-1 text-center py-1 rounded-md text-slate-300">Все</span>
          <span className="flex-1 text-center py-1 rounded-md bg-white/25 font-semibold">Не на этом iPhone</span>
        </div>
      </div>

      <div className="px-3 pb-2">
        <div className="flex items-center gap-1 rounded-md bg-white/10 px-2 py-1 text-[10px] text-slate-400">
          <Search size={11} /> Игры, приложения и другое
        </div>
      </div>

      <div className="divide-y divide-white/5">
        {APPS.map((a, i) => (
          <div
            key={i}
            className={`flex items-center gap-2 px-3 py-2 ${i === hi ? "bg-blue-500/10" : ""}`}
          >
            <img
              src={a.icon}
              alt={a.name}
              loading="lazy"
              className="w-8 h-8 rounded-[8px] object-cover border border-white/10"
            />
            <div className="min-w-0 flex-1">
              <div className="text-[11px] font-medium leading-tight truncate">{a.name}</div>
              <div className="text-[9px] text-slate-500">{a.date}</div>
            </div>
            <span className="relative shrink-0 grid place-items-center w-5 h-5">
              <DownloadCloud size={18} className="text-blue-400" />
              {i === hi && (
                <span
                  className="guide-highlight"
                  style={{ top: "-7px", left: "-7px", width: "32px", height: "32px", borderRadius: "9999px" }}
                />
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
